const invalidMinLength = (p: string) => p.length < 8;
const includeUppercase = (p: string) => /[A-Z]/.test(p);
const includeLowercase = (p: string) => /[a-z]/.test(p);
const includeNumber = (p: string) => /\d/.test(p);
const hasGoodLength = (p: string) => p.length >= 16;
const includeSpecialCharacter = (p: string) => /[~`!#@$%^&*+=\-[\]\\';,/{}|\\":<>?]/g.test(p);

export const getPasswordScore = (password: string) => {
  let score = 0;
  if (invalidMinLength(password)) return score;
  if (includeUppercase(password) && includeLowercase(password)) score++;
  if (includeNumber(password)) score++;
  if (hasGoodLength(password)) score++;
  if (includeSpecialCharacter(password)) score++;
  return score;
};
